import { jsx as o } from "react/jsx-runtime";
import t from "./roche-magnet.module.scss.js";
const s = () => /* @__PURE__ */ o("div", { className: t.magnet });
export {
  s as RocheUIMagnet
};
